export default __webpack_public_path__ + "static/media/img2.7c2ad161.jpg";